import React from "react";
import "./AddCustomerDetailsMobileView.css";
import CallIcon from "@mui/icons-material/Call";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

function AddCustomerDetailsMobileView({ preview, activeForm, setActiveForm }) {
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [orderSummary, setOrderSummary] = useState([]);
  const location = useLocation();

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    First_Name: "",
    Mobile_No: "",
    origin_address: "",
    Origin_Pin: "",
    Origin_City: "",
    Origin_State: "",
    sender_contact_no: "",
    sender_alternate_no: "",
    sender_alternate_email: "",
    alternate_number: "",
    Email:"",
  });

  const OpenRelocationForm = async (e) => {
    
    e.preventDefault();
    
    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerOrderSummary`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      
    } catch (error) {
      console.error("Error posting data:", error);
    }
    setActiveForm({
      customerDetails: false,
      relocationDetails: true,
      petDetails: false,
      preview: false,
      documentation: false,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderSummary(response.data.data[0]);
          setFirstItem(response.data.data[0]);

          getState();
          getCity(response.data.data[0].Origin_State);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

    getState();
  }, []);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function getCity(state_id) {
    if (state_id != null && state_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          setOriginCityResponse(response.data.data);
        });
    }
  }

  const handleSelectChangeOriginState = (event) => {
    // Handle the select input change and update the selected value
    firstItem.Origin_State = event.target.value;
    getCity(event.target.value);
  };

  function getState() {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    axios
      .get(`${baseAPI}adminget/GETState?stateID=0&countryID=0`, {
        headers: {
          Authorization: "Bearer " + storedToken,
        },
      })
      .then((response) => {
        setOriginStateResponse(response.data.data);
      });
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    // Update the state for the given field
    setFirstItem((prevItem) => {
      const updatedItem = {
        ...prevItem,
        [name]: value,
      };
      return updatedItem;
    });
  };

  return (
    <div style={{ marginBottom: preview ? "30px" : "0" }} className="">
      <div
        className="py-2"
        style={{
          borderRadius: "7px",
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          backgroundColor: "white",
        }}
      >
        <h1 style={{ fontSize: "20px", margin: "14px" }} className="heading">
          Customer Details
        </h1>
        {preview ? (
          <div
            style={{ paddingBottom: "30px" }}
            className="relocation-details-main-form px-3 m-0"
          >
            <div className="form-row row align-items-start">
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Lead ID
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.Relocation_ID}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Full Name
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.First_Name}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Contact Number
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.Mobile_No}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Alternative Number
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.alternate_number}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div style={{}} className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Email ID
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                    paddingRight: "10px",
                  }}
                >
                  {orderSummary.Email}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  Address
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                    paddingRight: "20px",
                  }}
                >
                  {" "}
                  {orderSummary.origin_address}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "29px",
                    paddingLeft: "2px",
                  }}
                >
                  Pin Code
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.Origin_Pin}
                </h4>
              </div>
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  State
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.origin_state1}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              
              <div className="col-md-3 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "20px",
                  }}
                >
                  City
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.origin_city1}
                </h4>
              </div>
            </div>
          </div>
        ) : (
          <form className="relocation-details-main-form">
            <div className="form-row row align-items-center px-0">
              <div className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Lead Id
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.relocation_id}
                  disabled
                />
              </div>
              <div className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Full Name
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.First_Name}
                  disabled
                />
              </div>
              <div style={{ position: "relative" }} className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Contact Number
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "29px" : "27px",
                    paddingTop: preview ? "0px" : "",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.Mobile_No}
                  disabled
                />
                <CallIcon
                  style={{
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "58px",
                    paddingLeft: "7px",
                    fontSize: preview ? "18px" : undefined,
                    paddingLeft: preview ? "1px" : "7px",
                  }}
                />
              </div>
              <div style={{ position: "relative" }} className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Alternate Number
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "29px" : "27px",
                    paddingTop: preview ? "0px" : "",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="number"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.alternate_number}
                  onChange={handleChange1}
                />
                <SmartphoneIcon
                  style={{
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "58px",
                    paddingLeft: "7px",
                    fontSize: preview ? "18px" : undefined,
                    paddingLeft: preview ? "1px" : "7px",
                  }}
                />
              </div>
            </div>
            <div className="form-row row align-items-center">
              <div style={{ position: "relative" }} className="col-md-6 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Email Address
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "29px" : "27px",
                    paddingTop: preview ? "0px" : "",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="email"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.Email}
                  onChange={handleChange1}
                />
                <MailOutlineIcon
                  style={{
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "58px",
                    paddingLeft: "7px",
                    fontSize: preview ? "18px" : undefined,
                    paddingLeft: preview ? "1px" : "7px",
                  }}
                />
              </div>
              <div className="col-md-6 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  Address
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.origin_address}
                  onChange={handleChange1}
                />
              </div>
            </div>
            <div className="form-row row align-items-center px-0">
              <div className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  PinCode
                </label>
                <input
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="Origin_Pin"
                  value={firstItem.Origin_Pin}
                  onChange={handleChange1}
                />
              </div>
              <div className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  State
                </label>
                <select
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  className="form-select m-0"
                  aria-label=""
                  name="Origin_State"
                  value={firstItem.Origin_State}
                  onChange={handleSelectChangeOriginState}
                >
                  <option value="0">Select an option</option>
                  {originStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "29px" }}
                  className=""
                  htmlFor=""
                >
                  City
                </label>
                <select
                  style={{
                    border: preview ? "none" : "1px solid #5B489D",
                    width: "100%",
                    fontSize: "14px",
                    paddingLeft: preview ? "0px" : "10px",
                    fontWeight: preview ? "bold" : "",
                  }}
                  className="form-select m-0"
                  aria-label="Default select example"
                  value={firstItem.Origin_City}
                  onChange={handleChange2}
                  name="Origin_City"
                >
                  <option value="">Select an option</option>
                  {originCityResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>
              
            </div>
            {preview ? null : (
              <>
                <hr style={{ marginTop: "46px", marginRight: "20px" }} />
                <div
                  style={{ textAlign: "end" }}
                  className="form-button-div mt-3 px-3"
                >
                  <button
                    onClick={OpenRelocationForm}
                    style={{
                      paddingBottom: "5px",
                      width: "129px",
                      fontSize: "14px",
                    }}
                    type="submit"
                    className="btn"
                  >
                    SAVE & NEXT <span style={{ fontSize: "20px" }}>&rarr;</span>
                  </button>
                </div>
              </>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default AddCustomerDetailsMobileView;
